import { render, staticRenderFns } from "./EventBlock.vue?vue&type=template&id=281cab5e"
import script from "./EventBlock.vue?vue&type=script&lang=js"
export * from "./EventBlock.vue?vue&type=script&lang=js"
import style0 from "./EventBlock.vue?vue&type=style&index=0&id=281cab5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports